<template>
    <Navbar></Navbar>
    <h4 style="margin: 10px">Histórico da vistoria {{idVistoria}}</h4>
    
    <!-- Area da tabela de historico -->
    <div class="table-responsive" style="margin-left: 10px; margin-right: 10px;">
        <table class="table table-bordered">
            <thead class="table table-bordered">
                <tr class="table">
                    <th scope="col">ID</th>
                    <th scope="col">Data Vistoria</th>
                    <th scope="col">Texto</th>   
                </tr>
            </thead>
            <tbody>
                <tr v-for="h in historico" :key="h.id">
                    <td>{{h.id}}</td>
                    <td>{{formatDate(h.data)}}</td>
                    <td>{{h.texto}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    
    <router-link to='/Home' style="margin-left: 10px;" title='Voltar para o início'>
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>
    </router-link>
    

</template>

<script>

import APIv2 from '../services/apiv2-endpoints'
import Navbar from '../components/Navbar.vue'
import moment from 'moment'


export default {
    name: 'Historico',
    components:{
        Navbar
    },
    created: function(){
        this.getHistorico()
    },
    
    data(){
        return{
            idVistoria: this.$route.query.idVistoria,
            historico: null
        }
    },

    methods: {
        getHistorico(){
            APIv2.historicoVistoria(this.idVistoria)
                .then(response => {
                    this.historico = response.data
                })
                .catch(err => {
                    console.log(err)
                })
        },
        formatDate (date){
            return moment(date).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style>
    
</style>